<template>
  <div class="columns is-multiline">
    <div class="column is-12" v-if="!quizEnded">
      <article class="message is-primary">
        <div class="message-header">
          <p>Quiz Results</p>
        </div>
        <div class="message-body">
          <p>To see the quiz results and ranking you need to end your quiz session.</p>
          <btn type="primary" @click="endQuiz">End The Quiz Session&nbsp;<font-awesome-icon v-if="loading" :icon="['fas', 'circle-notch']" :spin="true"></font-awesome-icon></btn>
        </div>
      </article>
    </div>
      <div class="column is-12" v-if="quizEnded">
      <article class="message is-primary">
        <div class="message-header">
          <p>{{ nickname }}, here is your score</p>
        </div>
        <div class="message-body">
          You have total score of {{ quizScore }}% and you finished in {{ humanizeDuration(time*1000) }}.
        </div>
      </article>
    </div>
    <div class="column is-12" v-if="quizEnded">
      <table class="table">
        <thead>
        <tr>
          <td>Rank</td>
          <td>Name</td>
          <td>Score</td>
          <td>Time</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(rank, key, index) in quizResults" :key="index" :class="{'is-selected': (key === session)}">
          <td>{{ index + 1 }}.</td>
          <td>{{ rank.nickname }}</td>
          <td>{{ rank.quiz_score }}%</td>
          <td>{{ humanizeDuration(rank.quiz_total_time*1000) }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="column is-12" v-if="quizEnded">
      <div class="buttons">
        <b-button type="is-facebook">
          <font-awesome-icon :icon="['fab', 'facebook-f']"></font-awesome-icon>
          Share on Facebook
        </b-button>
        <br>
        <b-button type="is-twitter">
          <font-awesome-icon :icon="['fab', 'twitter']"></font-awesome-icon>
          Share on Twitter
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Btn from '../atoms/Btn'

let humanizeDuration = require('humanize-duration')

export default {
  name: 'QuizResults',
  components: { Btn },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('tag', {
      session: 'getSessionId',
      nickname: 'getName',
      quizResults: 'getQuizResults',
      numberOfCorrectAnswers: 'getNumberOfCorrectAnswers',
      totalQuestions: 'getTotalOfQuestions',
      quizEnded: 'isQuizEnded'
    }),
    quizScore () {
      return Math.round((this.numberOfCorrectAnswers / this.totalQuestions) * 100)
    },
    time () {
      if (this.quizEnded && !this.loading && this.session in this.quizResults) {
        return this.quizResults[this.session].quiz_total_time
      } else {
        return 0
      }
    }
  },
  methods: {
    endQuiz () {
      this.loading = true
      setTimeout(() => this.$store.dispatch('tag/endQuiz', { quizScore: this.quizScore }).then(() => (this.loading = false)), 1000)
    },
    humanizeDuration (duration) {
      return humanizeDuration(duration)
    }
  }
}
</script>

<style scoped lang="scss">
table {
  thead td, tr.active > td {
    font-weight: bold;
  }
}
</style>
